'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createEDSTheme = require('./createEDSTheme');

Object.defineProperty(exports, 'createEDSTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createEDSTheme).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }